import type React from "react";

import styled from "styled-components";

import type { ChartType } from "../Chart/useChartData";

interface Props {
  currentValue?: number;
  sinceStart: string | null;
  chartType: ChartType;
  hasData: boolean;
  currentLabel?: string;
  sinceStartLabel: string;
  showDivider?: boolean;
}

export const ChartToolbar: React.FC<Props> = ({
  currentValue,
  sinceStart,
  chartType,
  hasData,
  currentLabel,
  sinceStartLabel,
  showDivider = true,
}) => (
  <ToolbarWrapper>
    <StatBlock>
      <StatLabel>{currentLabel}</StatLabel>
      <StatValue $chartType={chartType}>{hasData ? currentValue : "-"}</StatValue>
    </StatBlock>
    {showDivider && <StatDivider />}
    <StatBlock>
      <StatLabel>{sinceStartLabel}</StatLabel>
      <StatValue $chartType={chartType}>{hasData ? sinceStart : "-"}</StatValue>
    </StatBlock>
  </ToolbarWrapper>
);

const ToolbarWrapper = styled.div`
  display: flex;
  align-items: stretch;
`;

const StatBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const StatLabel = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.redesign.db60};
  font-weight: 400;
  white-space: wrap;
`;

const StatValue = styled.span<{ $chartType: ChartType }>`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  color: ${props =>
    props.$chartType === "physical-function" ? props.theme.colors.graph.function : props.theme.colors.graph.pain};
`;

const StatDivider = styled.div`
  width: 1px;
  background-color: ${props => props.theme.colors.redesign.db20};
  align-self: stretch;
  margin: 0 24px;
`;
